const inputs = document.querySelectorAll('.as-settings__affiliate-links__form-group input');

const updatePermalink = function() {
  const permalink = this.closest('td').querySelector('[data-siteurl]');
  const url = this.value;

  if (null === permalink) {
    return;
  }

  // eslint-disable-next-line yoda
  if ('' === url || typeof url === 'undefined') {
    permalink.innerHTML = 'No URL set';
  } else {
    permalink.innerHTML = `${permalink.dataset.siteurl}/${url.replace(/^\/+/, '').replace(/\/+$/, '')}`;
  }
};

for (let i = 0; i < inputs.length; i += 1) {
  inputs[i].addEventListener('keyup', updatePermalink, false);
  inputs[i].dispatchEvent(new Event('keyup'));
}
